import { render, staticRenderFns } from "./otorgaqr.vue?vue&type=template&id=6c81f4c3&"
import script from "./otorgaqr.vue?vue&type=script&lang=js&"
export * from "./otorgaqr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports